import { useFormContext, useWatch } from 'react-hook-form';

import { FUTURE_SCHEDULED_PAYRUN } from '@xemplo/gp-constants';
import { useGetPayschedulesQuery } from '@xemplo/pay-schedule-query';
import { useListBuilder } from '@xemplo/stateful-list-core';
import { V2 } from '@xemplo/text-dropdown';

import { FormFields } from '../../../create-amendment.types';
import * as S from '../../modal.styles';

export const PaySchedule = () => {
  const { control } = useFormContext<FormFields>();
  const businessUnit = useWatch({ control, name: 'businessUnit' });
  const payrun = useWatch({ control, name: 'payrun' });

  const { data: payschedules, isLoading } = useGetPayschedulesQuery({
    per_page: 500,
    page: 1,
    filter: { businessUnitId: businessUnit, isActive: true },
  });

  const payScheduleList = useListBuilder(payschedules?.payScheduleItems ?? []);

  if (payrun !== FUTURE_SCHEDULED_PAYRUN) {
    return null;
  }

  return (
    <S.FormLabel>
      Pay schedule
      <V2.TextDropdownRhf
        name="paySchedule"
        items={payScheduleList}
        placeholder="Select pay schedule(s)"
        aria-label="Pay schedule"
        disabled={isLoading}
        searchable
      />
    </S.FormLabel>
  );
};
